import React from "react";
import {Box, Card, CardContent, Chip, Divider, Stack, Typography, Skeleton} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import SimplePieChart from "../../shared/SimplePieChart";

export default function DashboardDistributionCard({loading, chartData, hasAccounting}) {
    return (
        <Card sx={{borderRadius: 3, height: "100%", boxShadow: "0 6px 24px rgba(0,0,0,0.06)"}}>
            <CardContent sx={{display: "flex", alignItems: "center", gap: 3}}>
                {loading ? <Skeleton variant="circular" width={180} height={180}/> : <SimplePieChart data={chartData}/>}
                <Box>
                    <Typography variant="h6" sx={{mb: 1}}>
                        Bestand Überblick
                    </Typography>
                    {chartData.map((entry) => (
                        <Box key={entry.label} sx={{display: "flex", alignItems: "center", mb: 0.5}}>
                            <Box sx={{width: 14, height: 14, bgcolor: entry.color, borderRadius: 0.5, mr: 1}}/>
                            <Typography variant="body2">
                                {entry.label}: {loading ? "-" : entry.value}
                            </Typography>
                        </Box>
                    ))}
                    <Divider sx={{my: 1.5}}/>
                    <Stack direction="row" gap={1} flexWrap="wrap">
                        <Chip component={RouterLink} to="/invoices" label="Rechnungen" clickable/>
                        {hasAccounting ? (
                            <>
                                <Chip component={RouterLink} to="/incomes" label="Einnahmen" clickable/>
                                <Chip component={RouterLink} to="/expenses" label="Ausgaben" clickable/>
                            </>
                        ) : (
                            <Chip
                                component={RouterLink}
                                to="/registration"
                                label="Buchhaltung freischalten"
                                clickable
                                color="warning"
                                variant="outlined"
                            />
                        )}
                    </Stack>
                </Box>
            </CardContent>
        </Card>
    );
}
